import { Component, ElementRef, OnDestroy, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountFunctionsService } from '../account-functions.service';
import { AccountFunction } from '../account-functions.types';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import clone from 'lodash-es/clone';

@Component({
  selector: 'account-functions-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccountFunctionsDetailsComponent implements OnInit, OnDestroy {
  accountFunctions: AccountFunction[];
  accountFunction: AccountFunction;
  replyFormActive: boolean;
  accountFunctionForm: UntypedFormGroup;

  // Private
  private _overlayRef: OverlayRef;
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {ActivatedRoute} _activatedRoute
   * @param {ElementRef} _elementRef
   * @param {Overlay} _overlay
   * @param {Router} _router
   * @param {ViewContainerRef} _viewContainerRef
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _elementRef: ElementRef,
    private _accountFunctionsService: AccountFunctionsService,
    private _overlay: Overlay,
    private _formBuilder: UntypedFormBuilder,
    private _router: Router,
    private _viewContainerRef: ViewContainerRef,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // Set the default
    this.replyFormActive = false;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.accountFunctionForm = this._formBuilder.group({
      id: [''],
      method_code: [''],
    });

    // Folders
    this._accountFunctionsService.accountFunctions$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((accountFunctions: AccountFunction[]) => {
        this.accountFunctions = accountFunctions;
      });

    // Mail
    this._accountFunctionsService.accountFunction$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((accountFunction: AccountFunction) => {
        this.accountFunction = accountFunction;
        this.accountFunctionForm.patchValue(accountFunction, { emitEvent: false });
      });

    this._accountFunctionsService.selectedAccountFunctionChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {});
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  discard() {}

  save() {
    let accountFunction = clone(this.accountFunctionForm.value);

    this._accountFunctionsService.saveAccountFunction(accountFunction).subscribe((af) => {});
  }

  publish() {
    this._accountFunctionsService.publishAccountFunction(this.accountFunction).subscribe((af) => {});
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
